import type { VisitableGraph } from '../interface';
import type { EID } from '../types';
import { ControlFlow } from './ControlFlow';
import { depthFirstSearch, type DFSVisitor } from './depthFirstSearch';

export function isForest<G, N, E>(graph: VisitableGraph<G, N, E>): boolean {
  return depthFirstSearch(graph, new IsForestVisitor<G, N, E>(), {
    roots: graph.roots
  });
}

class IsForestVisitor<G, N, E> implements DFSVisitor<G, N, E, boolean> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  backEdge(graph: VisitableGraph<G, N, E>, edge: EID): ControlFlow<boolean> {
    return ControlFlow.break(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  forwardOrCrossEdge(graph: VisitableGraph<G, N, E>, edge: EID): ControlFlow<boolean> {
    return ControlFlow.break(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  finish(graph: VisitableGraph<G, N, E>): boolean {
    return true;
  }
}
